import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateService } from '@ngx-translate/core';
import { RoutingService, UIService } from '@services';
import { ACTIVE_ERROR_TYPE, ActiveErrorData, queryParamShowDevices } from '@store';
import { ActiveErrorsHelper } from 'src/app/@store/active-errors/active-errors.helper';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import {
  SingleRoomControlOverlayTypeEnum,
  SingleRoomControlUrlTypeEnum,
} from '../../../installation-overlay.model';
import { LetDirective } from '@ngrx/component';

@Component({
  selector: 'app-power-limitation-statuses',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, LetDirective],
  templateUrl: './power-limitation-statuses.component.html',
  styleUrl: './power-limitation-statuses.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PowerLimitationStatusesComponent implements OnInit {
  @Input() powerLimitationStatus: ActiveErrorData;
  ACTIVE_ERROR_TYPE = ACTIVE_ERROR_TYPE;
  headerLabel: string;

  constructor(
    public uiService: UIService,
    private translate: TranslateService,
    private routingService: RoutingService
  ) {}

  ngOnInit(): void {
    this.setHeaderLabel();
  }

  navigateToDevices(): void {
    // Ignoring navigation within openSingleRoomControlOverlay due to additional query param
    this.routingService.addChildPathToUrl(SingleRoomControlUrlTypeEnum.SingleRoomControl, {
      [queryParamShowDevices]: true,
    });
    this.uiService.openSingleRoomControlOverlay(
      SingleRoomControlOverlayTypeEnum.SingleRoomControlDetails
    );
  }

  dismiss(): void {
    ActiveErrorsHelper.setLocalStorageIgnoredSmartNotes(this.powerLimitationStatus.id.toString());
  }

  private setHeaderLabel(): void {
    switch (this.powerLimitationStatus.type) {
      case ACTIVE_ERROR_TYPE.POWER_LIMITATION_CONSUMPTION:
        this.headerLabel = this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.CONSUMPTION_LIMIT'
        );
        break;
      case ACTIVE_ERROR_TYPE.SRC_DEVICE_OFFLINE:
        this.headerLabel = this.powerLimitationStatus?.content?.title;
        break;
      default:
        this.headerLabel = this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.FEED_IN_LIMITATION'
        );
        break;
    }
  }
}
